import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/group-of-company/client/GroupCompanyClient.tsx");
